import { payment_links as paymentLinks } from '#proto/index.qonto.cards_acceptance';

export const ConnectionStatus = paymentLinks.connections.firstparty.v2.ApiStatus;
export const DeactivationSource = paymentLinks.connections.firstparty.v2.ApiDeactivationSource;
export const DeactivationReasonCode =
  paymentLinks.connections.firstparty.v2.ApiDeactivationReasonCode;

export const ApiMethodStatusValue = paymentLinks.methods.firstparty.v1.ApiMethodStatusValue;
export const ApiMethodLocation = paymentLinks.methods.firstparty.v1.ApiMethodLocation;

export const ApiPaymentLinkStatus = paymentLinks.firstparty.v4.ApiPaymentLinkStatus;
export const ApiResourceType = paymentLinks.firstparty.v4.ApiResourceType;
export const ApiItemType = paymentLinks.firstparty.v4.ApiItemType;
export const ApiPaymentLinkRecurrenceType =
  paymentLinks.firstparty.v4.ApiPaymentLinkRecurrenceType;
export const ApiFrequencyRecurrence = paymentLinks.firstparty.v4.ApiFrequencyRecurrence;
export const ApiPaymentStatus = paymentLinks.firstparty.v4.ApiPaymentStatus;
export const ApiPaymentMethod = paymentLinks.firstparty.v4.ApiPaymentMethod;
export const ApiSearchSubscriptionPaymentsRequestSortField =
  paymentLinks.firstparty.v4.ApiSearchSubscriptionPaymentsRequestSortField;

export enum PaymentMethods {
  CreditCard = 'credit_card',
  BankTransfer = 'bank_transfer',
  ApplePay = 'apple_pay',
  Paypal = 'paypal',
  Ideal = 'ideal',
}
